//break string into lines of a certain length
export const stringSplitter = (
  string: string,
  charInLine: number,
): string[] => {
  const words = string.split(' ')
  let lines = []
  let line = ''
  for (let i = 0; i < words.length; i++) {
    if (line.length + words[i].length < charInLine) {
      line += words[i] + ' '
    } else {
      lines.push(line)
      line = words[i] + ' '
    }
  }
  lines.push(line)
  return lines
}

//format a string into sentence case
export const formatSentence = (sentence: string): string => {
  // Split the sentence by commas followed by optional spaces
  const parts = sentence.split(/,\s*/)

  // Capitalize the first letter of each part and lowercase the rest
  const formattedParts = parts.map((part, index) => {
    if (part.length > 0) {
      if (index === 0) {
        // Capitalize the first word
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
      } else {
        // Lowercase the subsequent words
        return part.toLowerCase()
      }
    }
    return part
  })

  // Join the formatted parts with a comma and a space
  const formattedSentence = formattedParts.join(', ')

  return formattedSentence
}

//remove duplicates from an array of strings
export const removeDuplicates = (strings: string[]): string[] => {
  const uniqueStrings = Array.from(new Set(strings))
  return uniqueStrings
}
